import React from "react";
import { ServicioTransporte } from "../../services/transporteServicios";
import { Badge, Card } from "react-bootstrap";
import { currencyFormat } from "../../utils/numberUtils";

const Tarifa = ({ tarifa }: { tarifa: ServicioTransporte }) => {
  return (
    <Card key={tarifa.id}>
      <Card.Body className="d-flex justify-content-between align-items-start">
        <div className="me-auto">
          <div className="fw-bold">{tarifa.nombre}</div>
          <div>{tarifa.descripcion}</div>
        </div>
        <div className="ms-2 me-auto"></div>
        <Badge bg="success" pill>
          {currencyFormat(tarifa.precio)}
        </Badge>
      </Card.Body>
    </Card>
  );
};

export default Tarifa;
